// eslint-disable-next-line jira/filename-case
export const PUBLISH_DRAFT_SUCCESS_FLAG_ID = 'publishDraftSuccess';
export const LINK_PAGE_SUCCESS_FLAG_ID = 'linkPageSuccess';
export const LINK_PAGE_FAILED_FLAG_ID = 'linkPageFailed';
